// extracted by mini-css-extract-plugin
export default {"editButton":"addAllowance_editButton__ldiNr","TableBody":"addAllowance_TableBody__BkDPP","deleteButton":"addAllowance_deleteButton__9JG3a"};